import constants from '@/constants';

const USGS_API_FIELDS = {
  PARAMETER_CD    : 'parameter_cd',

  DAY             : 'day_nu',
  MONTH           : 'month_nu',
  BEGIN_YR        : 'begin_yr',
  END_YR          : 'end_yr',

  MEAN_VALUE      : 'mean_va',
}

/**
 * OSF API client USGS Historical Data wrapper
 *
 * Definitely needs refactoring at some point. Consider moving most functionality to functions,
 * or moving some logic to SiteData.
 *
 * Currently only supports Discharge & GaugeHeight.
 */
export default class {

  // TODO: typify better than this
  flowVariables: Record<string, any> = {};

  constructor(rawDataRows: Array<any>) {

    // Group the records by parameter code
    const parameterCdsToData: Record<string, any> = {};
    rawDataRows.forEach(row => {
      let parameterCd = row[USGS_API_FIELDS.PARAMETER_CD];
      if (!parameterCdsToData[parameterCd]) {
        parameterCdsToData[parameterCd] = [];
      }
      parameterCdsToData[parameterCd].push(row)
    });

    // Extract discharge variable
    if (parameterCdsToData.hasOwnProperty(constants.FlowVariables.Discharge.parameterCd)) {
      let rawDischargeResults = parameterCdsToData[constants.FlowVariables.Discharge.parameterCd];
      this.flowVariables[constants.FlowVariables.Discharge.key] = this._buildHistoricalDatamap(rawDischargeResults);
    }

    // Extract gauge height variable
    if (parameterCdsToData.hasOwnProperty(constants.FlowVariables.GaugeHeight.parameterCd)) {
      let rawGaugeHeightResults = parameterCdsToData[constants.FlowVariables.GaugeHeight.parameterCd];
      this.flowVariables[constants.FlowVariables.GaugeHeight.key] = this._buildHistoricalDatamap(rawGaugeHeightResults);
    }

    console.log(`Historical values parameter codes: ${Object.keys(parameterCdsToData)}`)

  }

  //
  // Build this...
  //
  // "0101" : "987",
  // "0102" : "784",
  // ...
  // "1231" : "823"
  //
  // TODO: typify
  _buildHistoricalDatamap(rawHistoricalDataset: Record<string, any>): Record<string, any> {
    let result: Record<string, any> = {};
    rawHistoricalDataset.forEach((rawResult: any) => {
      const monthString = rawResult[USGS_API_FIELDS.MONTH].padStart(2, '0');
      const dayString   = rawResult[USGS_API_FIELDS.DAY].padStart(2, '0');
      const monthDayString = monthString + dayString;
      result[monthDayString] = rawResult[USGS_API_FIELDS.MEAN_VALUE];
    });
    return result;
  }

}
